import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { PRIVATE_TOP_PATH } from '@/routes/private';

type PostPaymentSubscriptionSession = {
  priceId: string;
  campaignCode?: string | null;
  isoCountryCode?: string;
};

type Response = {
  url: string;
};

export const postPaymentSubscriptionSession = ({
  priceId,
  campaignCode,
  isoCountryCode,
}: PostPaymentSubscriptionSession): Promise<Response> => {
  const successUrl = window.location.origin + PRIVATE_TOP_PATH;
  const cancelUrl = window.location.href;

  return axios.post('/api/v1/payments/subscription_session', {
    priceId,
    campaignCode: campaignCode ?? undefined,
    isoCountryCode,
    successUrl,
    cancelUrl,
  });
};

type QueryFnType = typeof postPaymentSubscriptionSession;

type Options = {
  config?: MutationConfig<QueryFnType>;
};

export const usePostPaymentSubscriptionSession = ({ config }: Options = {}) => {
  return useMutation({
    ...config,
    mutationFn: (args) => postPaymentSubscriptionSession(args),
  });
};
